import { useAuth0 } from '@auth0/auth0-react'
import { Box, Flex, Heading, Img, Text } from '@chakra-ui/react'
import { FC, useEffect, useState } from 'react'
import { Helmet } from 'react-helmet'

import generic from '@service/generic'

function formatPrevisao(previsao: string | null | undefined): string {
  if (!previsao) return 'Não informado'
  const date = new Date(previsao)
  if (isNaN(date.getTime())) return previsao
  return date.toLocaleString('pt-BR', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit'
  })
}

const Maintenance: FC = () => {
  const { loginWithRedirect, isLoading, user } = useAuth0()
  const [motivo, setMotivo] = useState<string>(
    sessionStorage.getItem('manutencao_motivo') || ''
  )
  const [previsao, setPrevisao] = useState<string>(
    sessionStorage.getItem('manutencao_previsao') || ''
  )

  useEffect(() => {
    if (!isLoading && !user) {
      loginWithRedirect()
    }
    generic
      .getMaintence('manutencao')
      .then(({ data: { data } }) => {
        if (data.valor === 'false') {
          window.location.href = '/'
        }
        setMotivo(data.motivo ?? '')
        setPrevisao(data.previsao ?? '')
      })
      .catch(() => {})
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLoading])

  return (
    <>
      <Helmet>
        <title>manutencao - SCL</title>
      </Helmet>
      <Box bg="green.600" h="100vh" overflowY="auto" color="gray.800">
        <Flex
          flexDir="column"
          alignItems="center"
          justifyContent="center"
          bg="green.600"
          borderRadius="8px"
          h="calc(100vh - 8px)"
          p={6}
        >
          <Img
            src="/assets/images/maintence.png"
            width={['60%', '60%', '50%']}
          ></Img>
          <Heading
            mb={5}
            fontSize={['40px', '40px', '50px']}
            fontWeight="800"
            color="white"
          >
            Oops! Sistema em Manutenção
          </Heading>
          <Box
            bg="green.700"
            borderRadius="12px"
            p={6}
            maxW="520px"
            w="100%"
            mt={2}
          >
            <Text fontSize="15px" color="green.200" fontWeight="600" mb={1}>
              Motivo
            </Text>
            <Text
              fontSize="17px"
              textAlign="left"
              fontWeight="700"
              color="white"
              mb={4}
            >
              {motivo || 'Não informado'}
            </Text>
            <Text fontSize="15px" color="green.200" fontWeight="600" mb={1}>
              Previsão de normalização
            </Text>
            <Text
              fontSize="17px"
              textAlign="left"
              fontWeight="700"
              color="white"
            >
              {formatPrevisao(previsao)}
            </Text>
          </Box>
          <Text
            maxW="460px"
            fontSize="15px"
            textAlign="center"
            fontWeight="600"
            color="green.200"
            mt={5}
          >
            Por enquanto, tente atualizar a página ou aguarde o retorno do
            sistema.
          </Text>
        </Flex>
      </Box>
    </>
  )
}

export default Maintenance
